export default __webpack_public_path__ + "static/media/ky.28799ec5.svg";